const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const getAppVersion = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/account/version`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error('Error al obtener la versión');
    }
    
    const data = await response.json();
    return data.version;
  } catch (error) {
    console.error('Error obteniendo versión:', error);
    return 'v1.0.0-dev';
  }
};
